<template lang="pug">
section.territorio
    BaseHeader#cadastrar-territorio(
        :titulo='$t("mensagens.territorio.labels.territorio")',
        icon='el-icon-plus',
        :btnTexto='$t("mensagens.territorio.cadastrarTerritorio")',
        :exibeBotao='true',
        @btnHeaderClicado='cadastrarTerritorio'
    )

    .view-container-base-header
        .d-flex.lista-territorios__container
            .lista-territorios__barra-pesquisa
                i.el-icon-search
                input.lista-territorios__barra-pesquisa__input(
                    v-model='search',
                    type='text',
                    :placeholder='$t("mensagens.territorio.procurePeloTerritorio")',
                    autocomplete='off',
                    @keyup.enter='onChangeSearchInput'
                )
            .lista-territorios__atualizar-container
                el-button.lista-territorios__btn-atualizar(
                    v-if='permissaoAmbiente(ambientes.PARAGUAY)'
                    type='primary',
                    icon='el-icon-refresh',
                    :loading='isAtualizando',
                    :disabled='isAtualizando',
                    @click='iniciarAtualizacao'
                ) {{ $t('mensagens.territorio.recalcularSaldo.titulo') }}
                el-button.lista-territorios__btn-exportar-informes(
                    v-if='permissaoAmbiente(ambientes.PARAGUAY)'
                    type='primary',
                    icon='el-icon-document',
                    :loading='isExportandoInformes',
                    :disabled='isExportandoInformes',
                    @click='iniciarExportacaoInformes'
                ) {{ $t('mensagens.territorio.exportarInformes.titulo') }}

            el-dropdown.action-button(trigger='click')
                el-button.btn-exportar-relatorio(
                    icon='el-icon-download',
                    type='primary',
                    v-if='permissaoAmbiente(ambientes.BRASIL)'
                ) &nbsp;&nbsp;&nbsp; {{ $t('mensagens.exportacao.exportar') }}
                el-dropdown-menu(slot='dropdown')
                    el-dropdown-item(
                        icon='el-icon-download',
                        @click.native='exportarRelatorio(true)'
                    ) {{ $t('mensagens.exportacao.simples') }}
                    el-dropdown-item(
                        icon='el-icon-download',
                        @click.native='exportarRelatorio(false)'
                    ) {{ $t('mensagens.exportacao.completa') }}
        .table
            el-table.table-territorios(
                :key="listagemTableKey('territorios', territorios, paginacao.paginaAtual)",
                height='100%',
                v-if='territorios.length > 0',
                :data='territorios',
                @sort-change='sortChangeRequest',
                style='width: 100%'
            )
                el-table-column(type='expand')
                    template(slot-scope='props')
                        el-descriptions.descricao-item-tabela(:size='"mini"')
                            el-descriptions-item(
                                :label='$t("mensagens.territorio.labels.pessoasProdutores")',
                                v-if='!permissaoAmbiente(ambientes.PARAGUAY) && props.row.representantes && props.row.representantes.length > 1'
                            )
                                .representantes(
                                    v-for='representante in props.row.representantes',
                                    :key='representante.id'
                                )
                                    p {{ representante.nomeRazaoSocial }} {{ representante.cpfCnpj ? `(${representante.cpfCnpj})` : '' }}
                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='props.row.representantes && props.row.representantes.length === 1'
                        )
                            el-descriptions-item.has-colon-not(
                                :label='$t("mensagens.territorio.territorioNaoPossuiPessoasAdicionais")'
                            )

                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='props.row.representantes && props.row.representantes.length === 0'
                        )
                            el-descriptions-item.has-colon-not(
                                :label='$t("mensagens.territorio.territorioNaoPossuiPessoas")'
                            )

                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='props.row.comercializacoes.length'
                        )
                            el-descriptions-item(
                                :label='$t("mensagens.territorio.comercializacoes")'
                            )
                                ul.comercializacoes-infor-lista
                                    li.comercializacoes-infor(
                                        v-for='(comercializacao, index) in props.row.comercializacoes',
                                        :key='index'
                                    )
                                        span.lista-comercializacao {{ comercializacao.produtoNome }} - {{ $t('mensagens.territorio.comercializacao.quantidade') }} {{ comercializacao.quantidade }} {{ comercializacao.unidadeMedidaSimbolo ? `(${comercializacao.unidadeMedidaSimbolo})` : '' }}
                                        span.lista-comercializacao(
                                            v-if='comercializacao.safraAno'
                                        ) - {{ $t('mensagens.territorio.comercializacao.safra') }}: {{ comercializacao.safraAno }}
                                        span.lista-comercializacao(
                                            v-if='comercializacao.numeroContrato'
                                        ) - {{ $t('mensagens.territorio.comercializacao.numeroContrato') }}: {{ comercializacao.numeroContrato }}
                                        span.lista-comercializacao(
                                            v-if='comercializacao.fornecedor'
                                        ) - {{ $t('mensagens.territorio.comercializacao.fornecedor') }}: {{ comercializacao.fornecedor }}
                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='!permissaoAmbiente(ambientes.PARAGUAY) && props.row.certificacoes.length'
                        )
                            el-descriptions-item(
                                :label='$t("mensagens.territorio.certificacoes")'
                            )
                                ul.certificacoes-infor-lista
                                    li.certificacoes-infor(
                                        v-for='(certificacao, index) in props.row.certificacoes',
                                        :key='index'
                                    ) {{ certificacao.nome }}

                        el-descriptions.descricao-item-tabela(:size='"mini"')
                            el-descriptions-item(
                                :label='$t("mensagens.territorio.labels.car") + ":"',
                                v-if='!permissaoAmbiente(ambientes.PARAGUAY) && props.row.cars && props.row.cars.length > 1'
                            )
                                .car-list-row
                                    .cars(
                                        v-for='car in props.row.cars',
                                        :key='car.codigo'
                                    )
                                        p {{ car.codigo }}
                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='!permissaoAmbiente(ambientes.PARAGUAY) && props.row.cars && props.row.cars.length === 1'
                        )
                            el-descriptions-item.has-colon-not(
                                :label='$t("mensagens.territorio.territorioNaoPossuiCarsAdicionais")'
                            )
                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='permissaoAmbiente(ambientes.PARAGUAY) && props.row.cars && props.row.cars.length === 1'
                        )
                            el-descriptions-item.has-colon-not(
                                :label='$t("mensagens.territorio.territorioNaoPossuiCarsAdicionaisPY")'
                            )

                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='!permissaoAmbiente(ambientes.PARAGUAY) && props.row.cars && props.row.cars.length === 0'
                        )
                            el-descriptions-item.has-colon-not(
                                :label='$t("mensagens.territorio.territorioNaoPossuiCarsAdicionais")'
                            )
                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='permissaoAmbiente(ambientes.PARAGUAY) && props.row.cars && props.row.cars.length === 0'
                        )
                            el-descriptions-item.has-colon-not(
                                :label='$t("mensagens.territorio.territorioNaoPossuiCarsAdicionaisPY")'
                            )

                el-table-column(
                    v-if='permissaoAmbiente(ambientes.PARAGUAY) || permissaoAmbiente(ambientes.ARGENTINA)',
                    prop='codigoLyra',
                    :label='$t("mensagens.territorio.labels.codigoLyra")',
                    min-width='150px',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.codigoLyra || '-' }}

                el-table-column(
                    prop='nome',
                    :label='isAlvorada ? "Fazenda" : $t("mensagens.territorio.labels.territorio")',
                    min-width='200px',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.nome }}

                el-table-column(
                    prop='representante',
                    :label='$t("mensagens.territorio.labels.pessoasDocumento")',
                    min-width='200',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        .representante(
                            v-if='scope.row.representantes && scope.row.representantes.length > 0'
                        )
                            p {{ scope.row.representantes[0].nomeRazaoSocial }}
                                span ({{ formatCpfCnpj(scope.row.documentoDecrypt[0]) }})
                                el-tag.ml-2(
                                    v-if='scope.row.representantes.length > 1',
                                    size='mini'
                                )
                                    | {{ scope.row.representantes.length - 1 }}
                        .representante(v-else)
                            p -

                el-table-column(
                    prop='municipio',
                    :label='$t("mensagens.territorio.labels.localidade")',
                    min-width='200px',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        p {{ scope.row.localidadeNome }}

                el-table-column(
                    :formatter='formatAreaHaTableColumn',
                    prop='areaHa',
                    :label='$t("mensagens.territorio.labels.areaHa")',
                    min-width='150px',
                    sortable='custom'
                )

                el-table-column(
                    v-if='!permissaoAmbiente(ambientes.PARAGUAY)',
                    prop='codigo',
                    :label='$t("mensagens.territorio.labels.car")',
                    min-width='300px',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        .car(
                            v-if='scope.row.cars && scope.row.cars.length > 0'
                        )
                            p.car-hiden-row {{ scope.row.cars[0].codigo }}
                            el-tag.ml-2(
                                v-if='scope.row.cars.length > 1',
                                size='mini'
                            )
                                | {{ scope.row.cars.length - 1 }}
                        .car(v-else)
                            p -

                el-table-column(
                    v-if='permissaoAmbiente(ambientes.PARAGUAY)',
                    prop='padron',
                    :label='$t("mensagens.territorio.labels.padron")',
                    min-width='100px',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        p(
                            v-if='scope.row.padron !== null && scope.row.padron !== "null"'
                        ) {{ scope.row.padron }}
                        p(v-else) -

                el-table-column(
                    v-if='permissaoAmbiente(ambientes.PARAGUAY)',
                    prop='finca',
                    :label='$t("mensagens.territorio.labels.finca")',
                    min-width='100px',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        p(
                            v-if='scope.row.finca !== null && scope.row.finca !== "null"'
                        ) {{ scope.row.finca }}
                        p(v-else) -

                el-table-column(
                    prop='idCliente',
                    :label='isAlvorada ? "BP Cliente" : $t("mensagens.territorio.labels.idCliente")',
                    min-width='150px',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        p(v-if='scope.row.idCliente') {{ scope.row.idCliente }}
                        p(v-else) -

                el-table-column(
                    prop='dataCadastroFormatada',
                    :label='$t("mensagens.territorio.labels.dataCadastro")',
                    min-width='170px',
                    sortable='custom'
                )

                el-table-column(
                    v-if='permissaoAmbiente(ambientes.PARAGUAY) && !isUsuarioLDC',
                    prop='saldoSoja',
                    min-width='180px',
                    sortable='custom'
                    align='center'
                )
                    template(slot='header')
                        span
                            | {{ $t("mensagens.territorio.labels.saldoDisponivel") }}

                    template(slot-scope='scope')
                        span(
                            v-if='!saldoFoiCalculado(scope.row.saldoTerritorioPy, "SOJA")'
                            style='font-weight: bold; color: gold'
                        )
                            span
                                i.mdi.mdi-information-outline(
                                    style='margin-right: 4px',
                                    :title='$t("mensagens.territorio.labels.saldoDisponivelInfo")'
                                )
                                | {{ $t('mensagens.territorio.labels.saldoNaoCalculado') }}

                        span(
                            v-else
                            style='font-weight: bold'
                            :style="`color: ${consultarSaldo(scope.row.saldoTerritorioPy, 'SOJA') === 0 ? 'red' : 'green'}`"
                        ) {{ consultarSaldo(scope.row.saldoTerritorioPy, 'SOJA')}}

                el-table-column(
                    v-if='isUsuarioLDC',
                    prop='saldoSoja',
                    min-width='170px',
                    sortable='custom'
                    align='center'
                )
                    template(slot='header')
                        span {{ $t("mensagens.territorio.labels.saldoDisponivelSoja") }}

                    template(slot-scope='scope')
                        span(
                            v-if='!saldoFoiCalculado(scope.row.saldoTerritorioPy, "SOJA")'
                            style='font-weight: bold; color: gold'
                        )
                            span
                                i.mdi.mdi-information-outline(
                                    style='margin-right: 4px'
                                    :title='$t("mensagens.territorio.labels.saldoDisponivelInfo")')
                                | {{ $t('mensagens.territorio.labels.saldoNaoCalculado') }}

                        span(
                            v-else
                            style='font-weight: bold'
                            :style="`color: ${consultarSaldo(scope.row.saldoTerritorioPy, 'SOJA') === 0 ? 'red' : 'green'}`"
                        ) {{ consultarSaldo(scope.row.saldoTerritorioPy, 'SOJA')}}

                el-table-column(
                    v-if='isUsuarioLDC',
                    prop='saldoMilho',
                    min-width='169px',
                    sortable='custom'
                    align='center'
                )
                    template(slot='header')
                        span {{ $t("mensagens.territorio.labels.saldoDisponivelMilho") }}

                    template(slot-scope='scope')
                        span(
                            v-if='!saldoFoiCalculado(scope.row.saldoTerritorioPy, "MILHO")'
                            style='font-weight: bold; color: gold'
                        )
                            span
                                i.mdi.mdi-information-outline(
                                    style='margin-right: 4px'
                                    :title='$t("mensagens.territorio.labels.saldoDisponivelInfo")')
                                | {{ $t('mensagens.territorio.labels.saldoNaoCalculado') }}

                        span(
                            v-else
                            style='font-weight: bold'
                            :style="`color: ${consultarSaldo(scope.row.saldoTerritorioPy, 'MILHO') === 0 ? 'red' : 'green'}`"
                        ) {{ consultarSaldo(scope.row.saldoTerritorioPy, 'MILHO')}}

                el-table-column(
                    :label='$t("mensagens.comuns.acoes")',
                    width='140px',
                    align='center'
                )
                    .template(slot-scope='scope')
                        el-dropdown.action-button(
                            @click.native='setAtivo(scope.row)',
                        )
                            span.el-dropdown-link
                                i.mdi.mdi-dots-vertical
                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    icon='el-icon-view',
                                    @click.native='goToTerritorioDashboard(scope.row)'
                                ) {{ $t('mensagens.operacao.acoes.visualizar') }}

                                el-dropdown-item(
                                    icon='el-icon-edit',
                                    @click.native='handleClickUpdate(scope.row)'
                                ) {{ $t('mensagens.operacao.acoes.editar') }}

                                el-dropdown-item(
                                    icon='el-icon-delete',
                                    @click.native='handleClickDelete(scope.row)'
                                ) {{ $t('mensagens.operacao.acoes.remover') }}

                                el-dropdown-item(
                                    v-if='scope.row && usuarioLogado.monitoramentoAccess && usuarioLogado.monitoramentoEnviar && scope.row.internacional === false',
                                    icon='el-icon-map-location',
                                    @click.native='handleClickSendToMonitormaneto(scope.row)'
                                ) {{ verificaMonitoramento }}

                                el-dropdown-item(
                                    v-if='scope.row.internacional === false && !permissaoAmbiente(ambientes.PARAGUAY)',
                                    icon='flow flow-environment',
                                    @click.native='goToDiagnosticoSocioambiental(scope.row)'
                                ) {{ $t('mensagens.diagnosticoSocioambiental.titulo') }}

                                el-dropdown-item(
                                    v-if='!usuarioLogado.operacaoCadastrante',
                                    icon='el-icon-download',
                                    @click.native='baixarKMLTerritorio(scope.row)'
                                ) {{ $t('mensagens.territorio.baixarPoligono') }}

                                el-dropdown-item(
                                    v-if='(!scope.row.saldoTerritorioPy || scope.row.saldoTerritorioPy?.length < 2) && permissaoAmbiente(ambientes.PARAGUAY)',
                                    :loading='loadingRecalcularSaldo',
                                    icon='el-icon-refresh'
                                    @click.native='recalcularSaldo(scope.row.id)'
                                ) {{ $t('mensagens.territorio.recalcularSaldo.titulo') }}

                template(slot='empty')
                    el-empty(
                        :description='$t("mensagens.territorio.voceNaoPossuiTerritoriosCadastrados")'
                    )

            .tabela-rodape.paginacao-direita
                .tabela-rodape--esquerda
                    p {{ totalTerritorios <= 1 ? totalTerritorios + $t('mensagens.territorio.territorio') : totalTerritorios + $t('mensagens.territorio.territorios') }}

                .tabela-rodape--pagination
                    el-pagination(
                        background,
                        :page-size='paginacao.tamanhoPagina',
                        :current-page.sync='paginacao.paginaAtual',
                        layout='prev, pager, next',
                        :total='totalTerritorios',
                        @current-change='fetchTerritorios'
                    )

    #modal-delete-territorio-are-you-sure.row(v-if='deleteTerritorioModal')
        el-dialog(:visible.sync='deleteTerritorioModal', width='500px')
            span(slot='title')
                h1.mb-2.font-weight-bold(style='text-align: left') {{ $t('mensagens.territorio.removerTerritorio') }}
            .column.d-flex.justify-content-center.align-items-center.flex-column
                p.mb-5.texto-modal(v-if='statusMonitoramento === "ATIVO"')
                    | {{ $t('mensagens.territorio.naoFoiPossivelRemoverTerritorioEmMonitoramento') }}

                p.mb16.texto-modal(
                    v-else-if='statusMonitoramento === "CANCELADO"'
                )
                    b.mb-2 Atenção!
                    br
                    | {{ $t('mensagens.territorio.territorioPossuiMonitoramentosCancelados') }}

                p.mb16.texto-modal(v-else)
                    | {{ $t('mensagens.territorio.desejaRemoverTerritorio') }}

                .buttons.mb16(v-show='statusMonitoramento !== "ATIVO"')
                    el-button(
                        size='mini',
                        @click='handleCloseModalDeleteTerritorio'
                    )
                        | {{ $t('mensagens.comuns.cancelar') }}
                    el-button(
                        type='primary',
                        size='mini',
                        @click='deleteTerritorio'
                    )
                        | {{ $t('mensagens.comuns.remover') }}

    SendOrEditMonitoramento(
        v-if='showMonitoramentoModal',
        :showMonitoramentoModal='showMonitoramentoModal',
        :selectedTerritorioNome='selectedTerritorio.nome',
        :selectedTerritorio='territorioParaMonitoramento',
        actionType='send'
    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import EmptyResult from '@/components/EmptyResult';
import SendOrEditMonitoramento from '@/components/areamonitorada/SendOrEditMonitoramento';
import { required } from 'vuelidate/lib/validators';
import territorioService from '@/services/TerritorioService';
import MonitoramentoService from '@/services/MonitoramentoService';
import formatters from '@/utils/formatters';
import validators from '@/utils/validations/validators';
import { mapActions, mapGetters, mapState } from 'vuex';
import UtilsService from '@/services/UtilsService';
import { isEmpty } from 'lodash';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import EventBus from '@/utils/eventBus';
import ToastAtualizacaoTerritorio from '@/components/territorio/ToastAtualizacaoTerritorio.vue';
import Vue from 'vue';

export default {
    name: 'index',
    components: {
        BaseHeader,
        EmptyResult,
        SendOrEditMonitoramento,
        ToastAtualizacaoTerritorio
    },
    data() {
        return {
            visible: false,
            territorios: [],
            totalTerritorios: 0,
            paginacao: {
                paginaAtual: 1,
                tamanhoPagina: 20
            },
            isAdding: false,
            territorio: {
                nomeTerritorio: null,
                nomeProdutorCpfCnpj: null,
                cityState: null,
                area: null
            },
            addTerritorioSuccess: false,
            search: null,
            deleteTerritorioModal: false,
            selectedTerritorio: {},
            selectedAction: null,
            territorioParaMonitoramento: {
                idTerritorio: null,
                cultura: null,
                dataPlantio: null,
                areaDoPlantio: null,
                idSafra: null,
                produtividade: null
            },
            statusMonitoramento: '',
            order: null,
            nomeColumn: null,
            verificaMonitoramento: false,
            ambientes: AmbientesEmpresas,
            isAtualizando: false,
            progressoAtualizacao: {
                atualizados: 0,
                total: 0
            },
            toastNotification: null,
            websocketSubscription: null,
            territorioAtualNome: '',
            loadingRecalcularSaldo: false,
            isExportandoInformes: false,
            websocketExportacaoSubscription: null
        };
    },
    validations: {
        territorio: {
            nomeTerritorio: {
                required
            }
        },
        territorioParaMonitoramento: {
            idSafra: { required }
        }
    },

    created() {
        this.fetchTerritorios();
        this.resetTerritorio();
        this.clearTerritoryTableData();
    },
    filters: {
        formatarAreaDuasCasas: function (value) {
            if (!value) return '';
            const valueString = value.toString();
            return (
                Math.round(Number(valueString.replace(',', '.')) * 100) / 100
            ).toFixed(2);
        }
    },

    methods: {
        ...mapActions([
            'setTerritorio',
            'clearTerritorio',
            'clearTerritoryTableData',
            'changeShowMonitoramentoModal'
        ]),

        permissaoAmbiente(ambiente) {
            return this.usuarioLogado.ambienteLogado === ambiente;
        },

        async exportarRelatorio(simplificado) {
            EventBus.$emit('emit-componente-carregando', {
                mostrarLoading: true,
                lockMessage: this.$t(
                    'mensagens.sistema.preparandoDadosParaDownload'
                )
            });
            const searchText = this.search || '';
            territorioService.exportarTerritorios(simplificado, searchText);

            await connect();
            if (this.usuarioLogado) {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/territorios/baixar-territorios`,
                    response => {
                        if (response) {
                            response = JSON.parse(response);
                            const base64Data = response.fileData;
                            const byteCharacters = atob(base64Data);
                            const byteArray = new Uint8Array(
                                byteCharacters.length
                            );
                            for (let i = 0; i < byteCharacters.length; i++) {
                                byteArray[i] = byteCharacters.charCodeAt(i);
                            }
                            const fileBlob = new Blob([byteArray], {
                                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                            });
                            const fileLink = document.createElement('a');
                            const fileURL =
                                window.URL.createObjectURL(fileBlob);
                            fileLink.href = fileURL;
                            const filename = response.filename;
                            fileLink.setAttribute('download', filename);
                            document.body.appendChild(fileLink);
                            fileLink.click();
                            document.body.removeChild(fileLink);

                            EventBus.$emit('emit-componente-carregando', {
                                mostrarLoading: false,
                                lockMessage: this.$t(
                                    'mensagens.sistema.preparandoDadosParaDownload'
                                )
                            });
                            disconnect();
                        }
                    }
                );
            } else {
                this.$notify.error({
                    message: 'Usuário deslogado!'
                });
            }
        },

        resetTerritorio() {
            this.$v.$reset();
            this.territorio = {};
        },

        async setAtivo(value) {
            if (this.usuarioLogado.monitoramentoAccess) {
                const response = await MonitoramentoService.verificarTerritorio(
                    value.id
                );
                const data = await response.data;
                if (!isEmpty(data)) {
                    this.verificaMonitoramento = this.$t(
                        'mensagens.territorio.atualizarMonitoramento'
                    );
                } else {
                    this.verificaMonitoramento = this.$t(
                        'mensagens.territorio.enviarParaMonitoramento'
                    );
                }
            }
        },

        getFiltros() {
            const filtro = {};
            filtro.size = this.paginacao.tamanhoPagina;
            filtro.page = this.paginacao.paginaAtual - 1;
            filtro.search = this.search || '';

            if (validators.validarCPF(this.search)) {
                filtro.search = formatters.cpfCnpjFormatToNumeral(this.search);
            }

            filtro.order = 'nome,asc';

            if (this.order && this.nomeColumn) {
                const nomesColunas = {
                    nome: 'nome_territorio',
                    representante: 'nome_representante',
                    municipio: 'nome_cidade',
                    areaHa: 'territorio_area',
                    codigoLyra: 'codigo_lyra',
                    padron: 'padron',
                    finca: 'finca',
                    dataCadastroFormatada: 'territorio_data_cadastro',
                    idCliente: 'territorio_id_cliente',
                    saldoSoja: 'saldo_soja',
                    saldoMilho: 'saldo_milho'
                };
                const sort = nomesColunas[this.nomeColumn];
                if (sort) {
                    filtro.order = `${sort},${this.order}`;
                }
            }
            return filtro;
        },

        async fetchTerritorios() {
            let filtro = this.getFiltros();
            const { data } = await territorioService.findAll(filtro);
            this.totalTerritorios = data.totalElements;
            this.territorios = data.content;
        },

        cadastrarTerritorio() {
            this.territorioData.value = 'add';
            this.$router.push({ name: 'CadastrarEditarTerritorio' });
        },

        goToTerritorioDashboard({ id }) {
            this.$router.push({
                name: 'VisualizarTerritorio',
                params: { idTerritorio: id }
            });
        },

        async handleClickUpdate(value) {
            try {
                const response = await territorioService.findById(value.id);
                const result = response.data;

                result.value = 'edit';
                this.setTerritorio(result);

                this.$router.push({
                    name: 'CadastrarEditarTerritorio',
                    params: { idTerritorio: value.id }
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.erroEditarTerritorio'
                    )
                });
            }
        },

        deleteTerritorio() {
            territorioService
                .delete(this.selectedTerritorio.id)
                .then(response => {
                    if (response.status === 200) {
                        this.deleteTerritorioModal = false;
                        this.fetchTerritorios();
                        this.$notify.success({
                            message: this.$t(
                                'mensagens.territorio.removidoComSucesso'
                            )
                        });
                    } else {
                        this.$notify.error({
                            message: this.$t(
                                'mensgens.territorio.erroAoRemoverTerritorio'
                            )
                        });
                    }
                });
        },

        async handleClickDelete({ id }) {
            try {
                const { data } = await territorioService.getStatusMonitoramento(
                    id
                );

                this.statusMonitoramento = data;
                this.selectedTerritorio.id = id;
                this.deleteTerritorioModal = true;
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.erroAoVerificarStatusMonitoramentos'
                    )
                });
            }
        },

        handleCloseModalDeleteTerritorio() {
            this.deleteTerritorioModal = false;
        },

        onChangeSearchInput() {
            this.paginacao.paginaAtual = 1;
            this.fetchTerritorios();
        },

        formatCpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatTocpfCnpj(cpfCnpj);
        },

        formatAreaHaTableColumn(row, column, areaHa, index) {
            return formatters.maxFormatNumber(areaHa, 2);
        },

        handleClickSendToMonitormaneto(value) {
            this.selectedTerritorio = value;
            this.territorioParaMonitoramento.idTerritorio =
                this.selectedTerritorio.id;
            this.changeShowMonitoramentoModal();
        },

        sendToMonitoramento() {
            this.$v.territorioParaMonitoramento.$touch();
            if (this.$v.territorioParaMonitoramento.$invalid) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.preenchaCampoObrigatorio'
                    )
                });
            } else {
                MonitoramentoService.envioAreaMonitoramento(
                    this.territorioParaMonitoramento
                )
                    .then(response => {
                        if (response.status === 200) {
                            this.$notify.success({
                                message: this.$t(
                                    'mensagens.territorio.enviadoMonitoramentoComSucesso'
                                )
                            });

                            this.$router.push({ name: 'Monitoramento' });
                        } else {
                            this.$notify.error({
                                message: this.$t(
                                    'mensagens.territorio.erroAoEnviarTerritorioMonitoramento'
                                )
                            });
                        }
                    })
                    .catch(() => {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.territorio.erroAoEnviarTerritorioMonitoramento'
                            )
                        });
                    });
            }
        },

        utf8Decode(municipio) {
            return formatters.utf8Decode(municipio);
        },

        goToDiagnosticoSocioambiental({ id }) {
            this.$router.push({
                name: 'TerritorioSocioambiental',
                params: { idTerritorio: id }
            });
        },

        sortChangeRequest(column) {
            this.order = null;

            if (column.order === 'ascending') {
                this.order = 'asc';
            } else if (column.order === 'descending') {
                this.order = 'desc';
            }
            this.nomeColumn = column.prop;
            this.fetchTerritorios();
        },

        baixarKMLTerritorio({ id }) {
            territorioService.findById(id).then(({ data }) => {
                UtilsService.baixarKMLdeGeometria(data.geometria);
            });
        },

        saldoFoiCalculado(saldos, cultura) {
            if (saldos === null) return false;

            const saldoCultura = saldos?.filter(saldo => saldo.cultura === cultura);
            if (saldoCultura.length === 0) return false;

            return true;
        },

        consultarSaldo(saldos, cultura) {
            if (saldos === null) return false;

            const saldoCultura = saldos?.filter(saldo => saldo.cultura === cultura);
            if (saldoCultura.length === 0) return false;

            return saldoCultura[0].saldoCapacidadeProdutiva;
        },

        async recalcularSaldo(idTerritorio) {
            this.loadingRecalcularSaldo = true;

            try {
                await territorioService.recalcularSaldoPorId(idTerritorio);

                this.$notify.success({
                    message: this.$t(
                        'mensagens.sistema.territorioComSucesso'
                    )
                });
            } catch (error) {
                this.$notify.error({
                    message: error.response.data.message
                });
            } finally {
                this.loadingRecalcularSaldo = false;
                this.fetchTerritorios();
            }
        },

        async iniciarAtualizacao() {
            if (this.isAtualizando) {
                return;
            }

            this.inicializarProgresso();
            this.mostrarToastProgresso();
            await this.conectarWebSocketRecalculo();
        },

        inicializarProgresso() {
            this.isAtualizando = true;
            this.progressoAtualizacao = {
                atualizados: 0,
                total: this.totalTerritorios || 100
            };
        },

        mostrarToastProgresso() {
            this.fecharToastExistente();

            const mensagemHtml = this.criarMensagemToast();
            this.toastNotification = this.$notify({
                title: this.$t('mensagens.territorio.recalcularSaldo.toast.titulo'),
                message: mensagemHtml,
                type: 'info',
                duration: 0,
                dangerouslyUseHTMLString: true,
                customClass: 'toast-atualizacao-territorio',
                showClose: true
            });
        },

        fecharToastExistente() {
            if (this.toastNotification) {
                this.toastNotification.close();
                this.toastNotification = null;
            }
        },

        criarMensagemToast() {
            try {
                const { atualizados, total } = this.progressoAtualizacao;
                const percentual = this.progressoPercentual;
                const textoProcessando = this.$t('mensagens.territorio.recalcularSaldo.toast.processando');
                const textoTerritorios = this.$t('mensagens.territorio.recalcularSaldo.toast.territoriosProcessados');

                const ComponentClass = Vue.extend(ToastAtualizacaoTerritorio);
                const instance = new ComponentClass({
                    propsData: {
                        atualizados,
                        total,
                        percentual,
                        textoProcessando,
                        textoTerritorios
                    },
                    parent: this
                });

                instance.$mount();
                const html = instance.$el.outerHTML;
                instance.$destroy();
                return html;
            } catch {
                return this.criarMensagemToastFallback();
            }
        },

        criarMensagemToastFallback() {
            const { atualizados, total } = this.progressoAtualizacao;
            const percentual = this.progressoPercentual;
            const textoProcessando = this.$t('mensagens.territorio.recalcularSaldo.toast.processando');
            const textoTerritorios = this.$t('mensagens.territorio.recalcularSaldo.toast.territoriosProcessados');

            return `
                <div class="toast-atualizacao-territorio__content">
                    <div class="toast-atualizacao-territorio__info">
                        <i class="el-icon-loading toast-atualizacao-territorio__icon"></i>
                        <span class="toast-atualizacao-territorio__texto">${textoProcessando}</span>
                    </div>
                    <div class="toast-atualizacao-territorio__progresso">
                        <div class="toast-atualizacao-territorio__barra">
                            <div class="toast-atualizacao-territorio__barra__fill" style="width: ${percentual}%"></div>
                        </div>
                        <div class="toast-atualizacao-territorio__contador">
                            <span class="toast-atualizacao-territorio__contador__numero">${atualizados}</span>
                            <span class="toast-atualizacao-territorio__contador__separador">/</span>
                            <span class="toast-atualizacao-territorio__contador__total">${total}</span>
                            <span class="toast-atualizacao-territorio__contador__texto">${textoTerritorios}</span>
                        </div>
                        <div class="toast-atualizacao-territorio__percentual">${percentual}%</div>
                    </div>
                </div>
            `;
        },

        atualizarToastProgresso() {
            if (!this.toastNotification) {
                this.mostrarToastProgresso();
                return;
            }

            this.$nextTick(() => {
                const notificationEl = document.querySelector(
                    '.toast-atualizacao-territorio .el-notification__content'
                );
                if (notificationEl) {
                    const novaMensagem = this.criarMensagemToast();
                    notificationEl.innerHTML = novaMensagem;
                }
            });
        },

        async conectarWebSocketRecalculo() {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.territorio.recalcularSaldo.erroConexaoWebSocket')
                });
                this.isAtualizando = false;
                this.fecharToastExistente();
                return;
            }

            if (!this.usuarioLogado) {
                this.$notify.error({
                    message: this.$t('mensagens.sistema.usuarioDeslogado')
                });
                this.isAtualizando = false;
                this.fecharToastExistente();
                disconnect();
                return;
            }

            const idGrupo = this.usuarioLogado.idGrupo || this.usuarioLogado.grupoEmpresarial?.id;
            if (!idGrupo) {
                this.$notify.error({
                    message: 'ID do grupo não encontrado. Contate o suporte.'
                });
                this.isAtualizando = false;
                this.fecharToastExistente();
                disconnect();
                return;
            }

            const topico = `recalculo-saldo/${idGrupo}`;

            this.websocketSubscription = subscribe(topico, response => {
                this.handleWebSocketMessage(response);
            });

            await new Promise(resolve => setTimeout(resolve, 500));

            try {
                await territorioService.recalcularSaldoEmMassa();
            } catch (error) {
                this.$notify.error({
                    message:
                        error.response?.data?.message ||
                        this.$t('mensagens.territorio.recalcularSaldo.erroIniciarRecalculo')
                });
                this.isAtualizando = false;
                this.fecharToastExistente();
                disconnect();
            }
        },

        handleWebSocketMessage(response) {
            if (!response) {
                return;
            }

            try {
                const data = JSON.parse(response);

                if (data && typeof data === 'object' && data.idTerritorio !== undefined) {
                    this.handleRecalculoProgresso(data);
                } else if (typeof data === 'string' || (data && typeof data === 'string')) {
                    this.handleRecalculoConcluido(data);
                }
            } catch (error) {
                if (typeof response === 'string') {
                    this.handleRecalculoConcluido(response);
                }
            }
        },

        handleRecalculoProgresso(evento) {
            this.progressoAtualizacao.atualizados = evento.indice || 0;
            this.progressoAtualizacao.total = evento.total || this.totalTerritorios;
            this.territorioAtualNome = evento.nomeTerritorio || '';
            this.atualizarToastProgresso();
        },

        handleRecalculoConcluido(mensagem) {
            this.finalizarAtualizacao(mensagem);
        },

        desconectarWebSocket() {
            disconnect();
            this.websocketSubscription = null;
        },

        finalizarAtualizacao(mensagem) {
            setTimeout(() => {
                this.fecharToastExistente();
                this.isAtualizando = false;
                this.fetchTerritorios();
                this.mostrarNotificacaoSucesso(mensagem);
                this.desconectarWebSocket();

                setTimeout(() => {
                    this.limparProgresso();
                }, 2000);
            }, 500);
        },

        mostrarNotificacaoSucesso(mensagemBackend) {
            this.$notify.success({
                title: this.$t('mensagens.territorio.recalcularSaldo.toast.concluido'),
                message: mensagemBackend || this.$t('mensagens.territorio.recalcularSaldo.toast.sucesso'),
                duration: 4000
            });
        },

        limparProgresso() {
            this.progressoAtualizacao = {
                atualizados: 0,
                total: 0
            };
            this.territorioAtualNome = '';
        },

        async iniciarExportacaoInformes() {
            if (this.isExportandoInformes) {
                return;
            }

            this.isExportandoInformes = true;
            await this.conectarWebSocketExportacaoInformes();
        },

        async conectarWebSocketExportacaoInformes() {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.territorio.exportarInformes.erroConexaoWebSocket')
                });
                this.isExportandoInformes = false;
                return;
            }

            if (!this.usuarioLogado) {
                this.$notify.error({
                    message: this.$t('mensagens.sistema.usuarioDeslogado')
                });
                this.isExportandoInformes = false;
                disconnect();
                return;
            }

            const idGrupo = this.usuarioLogado.idGrupo || this.usuarioLogado.grupoEmpresarial?.id;
            if (!idGrupo) {
                this.$notify.error({
                    message: 'ID do grupo não encontrado. Contate o suporte.'
                });
                this.isExportandoInformes = false;
                disconnect();
                return;
            }

            const topico = `exportar-informes/${idGrupo}`;

            this.websocketExportacaoSubscription = subscribe(topico, response => {
                this.handleWebSocketExportacaoMessage(response);
            });

            await new Promise(resolve => setTimeout(resolve, 500));

            try {
                await territorioService.exportarInformesEmMassa();

                this.$notify.info({
                    title: this.$t('mensagens.territorio.exportarInformes.toast.titulo'),
                    message: this.$t('mensagens.territorio.exportarInformes.toast.processando'),
                    duration: 0,
                    customClass: 'toast-exportar-informes'
                });
            } catch (error) {
                this.$notify.error({
                    message:
                        error.response?.data?.message ||
                        this.$t('mensagens.territorio.exportarInformes.erroIniciarExportacao')
                });
                this.isExportandoInformes = false;
                this.desconectarWebSocketExportacao();
            }
        },

        handleWebSocketExportacaoMessage(response) {
            if (!response) return;

            try {
                const data = JSON.parse(response);

                if (data?.nomeArquivo && data?.base64) {
                    const bytes = atob(data.base64);
                    const arr = new Uint8Array(bytes.length);
                    for (let i = 0; i < bytes.length; i++) {
                        arr[i] = bytes.charCodeAt(i);
                    }
                    const blob = new Blob([arr], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = data.nomeArquivo;
                    a.click();
                    URL.revokeObjectURL(url);
                    this.finalizarExportacaoInformes(null);

                } else {
                    this.finalizarExportacaoInformes(typeof data === 'string' ? data : null);
                }
            } catch {
                if (typeof response === 'string') {
                    this.finalizarExportacaoInformes(response);
                }
            }
        },
        base64ToBlob(base64, mimeType) {
            const bytes = atob(base64);
            const arr = new Uint8Array(bytes.length);
            for (let i = 0; i < bytes.length; i++) {
                arr[i] = bytes.charCodeAt(i);
            }
            return new Blob([arr], { type: mimeType });
        },
        finalizarExportacaoInformes(mensagem) {
            setTimeout(() => {
                this.isExportandoInformes = false;
                this.$notify.success({
                    title: this.$t('mensagens.territorio.exportarInformes.toast.concluido'),
                    message: mensagem || this.$t('mensagens.territorio.exportarInformes.toast.sucesso'),
                    duration: 4000
                });
                this.desconectarWebSocketExportacao();
            }, 500);
        },

        desconectarWebSocketExportacao() {
            disconnect();
            this.websocketExportacaoSubscription = null;
        }
    },
    beforeDestroy() {
        this.desconectarWebSocket();
        this.desconectarWebSocketExportacao();
        this.fecharToastExistente();
    },
    computed: {
        ...mapGetters([
            'showMonitoramentoModal',
            'territorioData',
            'usuarioLogado',
            'isAlvorada'
        ]),
        ...mapState(['usuarioLogado']),
        isUsuarioLDC() {
            return this.usuarioLogado.isLDC || this.usuarioLogado.isLDCRevenda;
        },
        progressoPercentual() {
            if (this.progressoAtualizacao.total === 0) {
                return 0;
            }
            return Math.round(
                (this.progressoAtualizacao.atualizados / this.progressoAtualizacao.total) * 100
            );
        }
    }
};
</script>

<style lang="scss">
.territorio {
    height: 100%;
    width: 100%;
    overflow-y: auto;

    button {
        width: fit-content;
        cursor: pointer;
    }

    .lista-territorios__barra-pesquisa {
        margin-right: 12px;
        flex: 1;
        height: 46px;
        border-radius: 5px;
        color: var(--primary);
        margin-bottom: 20px;
        display: flex;
        justify-content: center;
        box-shadow: 0 1px 5px 0 var(--block-shadow);
        background-color: var(--white);

        i.el-icon-search {
            color: var(--gray);
            font-size: 16px;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        .lista-territorios__barra-pesquisa__input {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            border-radius: 5px;
            color: var(--primary);
        }
    }

    .lista-territorios__container {
        display: flex;
        align-items: flex-start;
        gap: 12px;
    }

    .lista-territorios__atualizar-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1rem;
        margin-bottom: 20px;
        flex-shrink: 0;

        .lista-territorios__btn-atualizar {
            height: 46px;
            width: 100%;
            border-radius: 5px;
            box-shadow: 0 1px 5px 0 var(--block-shadow);
        }
    }

    .btn-exportar-relatorio {
        width: 200px;
        height: 46px;
    }

    .required-text {
        color: var(--danger);
    }

    #end-add-territorio-button {
        p {
            cursor: pointer;
        }
    }

    .el-table {
        border-radius: 5px 5px 0 0 !important;

        .cell {
            word-break: break-word !important;
        }

        .action-button {
            cursor: pointer;
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
        }
    }

    .table-territorios {
        height: 100%;
        width: 100%;
        background-color: var(--white);
        border-radius: $default-border-radius;
        border-color: var(--default-border-color);
    }

    .table {
        height: calc(100vh - 312px);

        .tabela-rodape {
            height: 54px;
            background: var(--white);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 14px 10px 5px;
            border-radius: 0 0 5px 5px;

            .tabela-rodape--esquerda p {
                margin-bottom: 0;
                color: var(--primary);
                margin-left: 10px;
            }

            .tabela-rodape--pagination {
                .el-pager li.active {
                    color: var(--white);
                    font-weight: 900;
                    background: var(--primary);
                }

                .el-pager li {
                    padding: 0 4px;
                    background: var(--white);
                    vertical-align: top;
                    display: inline-block;
                    font-size: 13px !important;
                    min-width: 28px !important;
                    height: 28px !important;
                    line-height: 28px !important;
                    box-sizing: border-box;
                    text-align: center;
                    margin: 0;
                    border-radius: 2px;
                    color: var(--primary);
                }

                .el-pagination button {
                    height: 28px;
                }
            }
        }
    }

    .el-dialog__body {
        padding: 5px 20px;
        color: var(--text-disabled);
        font-size: 14px;
        word-break: break-all;
    }

    .buttons {
        width: 100%;
        gap: 16px;
        display: flex;
        justify-content: space-between;
    }

    .vw-100 {
        width: 100%;
    }

    .el-descriptions-item__container .el-descriptions-item__content {
        display: flex;
        flex-direction: column;
        column-count: 3;
    }

    .car-list-row {
        display: grid;
        grid-template-columns: auto auto auto;
        width: 100%;
        column-gap: 10px;
    }

    .car {
        display: flex;
    }

    .car-hiden-row {
        max-width: 55ch;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .el-descriptions-item__label.has-colon::after {
        content: '' !important;
    }
}

.example-showcase .el-dropdown-link {
    cursor: pointer;
    color: var(--el-color-primary);
    display: flex;
    align-items: center;
}

#modal-delete-territorio-are-you-sure {
    text-align: center;
}

#modal-diagnostico-socioambiental {
    text-align: center;

    word-break: keep-all !important;
}

.mb16 {
    margin-bottom: 16px;
}

.justify-content-between.mb-3 {
    display: flex;
    margin-top: 25px;
}

ul.certificacoes-infor-lista {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    flex-direction: row;
}

.certificacoes-infor {
    margin-right: 29px;
}

ul.comercializacoes-infor-lista {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    flex-direction: column;
    padding-left: 14px;
    gap: 14px;
}

li.comercializacoes-infor {
    list-style: none;
}

.texto-modal {
    word-break: break-word !important;
}

.lista-comercializacao {
    padding-right: 5px;
    display: inline-flex;
}

.toast-atualizacao-territorio {
    min-width: 380px;
    max-width: 450px;

    .el-notification__content {
        margin: 0;
    }

    .el-notification__title {
        font-weight: 600;
        color: var(--primary);
        margin-bottom: 12px;
        font-size: 16px;
    }

    .el-notification__message {
        line-height: 1.5;
    }
}
</style>
